import Vue from "vue";
import { BootstrapVue, BootstrapVueIcons } from "bootstrap-vue";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import store from "./store";
import axios from "axios";
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate';
import * as rules from "vee-validate/dist/rules";


Vue.config.productionTip = false;

// Install VeeValidate rules and localization
Object.keys(rules).forEach(rule => {
  extend(rule, rules[rule]);

});

extend('isNum', {
  validate: value => {
    return !isNaN(value) && value != 0;
  },
  message: 'Enter weight greater than "0".'
});

extend('required', {
  message: 'Enter weight greater than "0".'
});


// Install VeeValidate components globally
Vue.component("ValidationObserver", ValidationObserver);
Vue.component("ValidationProvider", ValidationProvider);

Vue.use(BootstrapVue);
Vue.use(BootstrapVueIcons);

axios.defaults.baseURL = process.env.VUE_APP_ROOT_API;


new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
